/* Happy Tabbies – Galerie, Tabs, Zahlen, Popup */
(() => {
  document.querySelectorAll('[data-ht-gallery]').forEach((g) => {
    const track = g.querySelector('.ht-gallery__track');
    const slides = [...track.children];
    const marks = [...g.querySelectorAll('.ht-gallery__thumb, .ht-gallery__dots span')];
    const setActive = (i) => marks.forEach((m) => m.classList.toggle('is-active', +m.dataset.index === i));
    g.querySelectorAll('.ht-gallery__thumb').forEach((t) =>
      t.addEventListener('click', () => track.scrollTo({ left: slides[+t.dataset.index].offsetLeft, behavior: 'smooth' }))
    );
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setActive(Math.round(track.scrollLeft / track.clientWidth)));
    }, { passive: true });
  });

  document.querySelectorAll('[data-ht-tabs]').forEach((box) => {
    const btns = box.querySelectorAll('.ht-tabs__btn');
    const panels = box.querySelectorAll('.ht-tabs__panel');
    btns.forEach((b, i) => b.addEventListener('click', () => {
      btns.forEach((x, j) => { x.classList.toggle('is-active', i === j); x.setAttribute('aria-selected', i === j); });
      panels.forEach((p, j) => p.classList.toggle('is-active', i === j));
    }));
  });

  const counters = document.querySelectorAll('[data-ht-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      const el = e.target, end = parseInt(el.dataset.htCount, 10) || 0, t0 = performance.now();
      const step = (t) => { const k = Math.min((t - t0) / 1400, 1); el.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    }), { threshold: 0.4 });
    counters.forEach((c) => { c.textContent = '0'; io.observe(c); });
  }

  document.querySelectorAll('[data-ht-open]').forEach((b) => b.addEventListener('click', () => document.getElementById(b.dataset.htOpen)?.showModal()));
  document.querySelectorAll('.ht-dialog').forEach((d) => {
    d.addEventListener('click', (e) => { if (e.target === d || e.target.closest('.ht-dialog__close')) d.close(); });
  });

  document.querySelectorAll('[data-ht-buy]').forEach((a) => a.addEventListener('click', (e) => {
    const target = document.getElementById('ht-buy');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }));
})();
